import React from 'react';
import { Typography } from '@mui/material';
import styles from './TPOEmptyTableTypography.module.scss';

const TPOEmptyTableTypography = ({ text }: { text: string }) => {
  return <Typography className={styles.EmptyList}>{text}</Typography>;
};

export default TPOEmptyTableTypography;
